import { Skeleton } from '@mui/material'
import styled from 'styled-components';

export const SkeletonCardNR1Container = styled.div<{ themeState: { isDark: boolean } }>`
  background: ${props => props.themeState.isDark !== true ? '#ffffff' : '#1E1E1E'};
  border-radius: 12px;
  padding: 28px 24px;
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
  border: 1px solid #e5e7eb;
  flex: 1;
  max-width: 400px;
`;

export const SkeletonCardValue = styled(Skeleton)`
  && {
    margin: 0 0 12px 0;
  }
`;

export const SkeletonCardTitle = styled(Skeleton)`
  && {
    margin: 0 0 8px 0;
  }
`;

export const SkeletonCardDescription = styled(Skeleton)``;